import styles from "./LeftPanel.module.css";
import ColumnButton from "../../components/ColumnButton";
import { FunctionComponent } from "react";
import { TColumnName } from "../../types";

type TProps = {
  columns: TColumnName[];
  onClick: (column: TColumnName) => void;
  selectedColumn?: TColumnName;
  render?: (column: TColumnName) => string;
};

const ColumnSection: FunctionComponent<TProps> = (props) => (
  <div className={styles.columns}>
    {props.columns.length
      ? props.columns.map((column) => (
          <ColumnButton
            key={column}
            isActive={props.selectedColumn === column}
            onClick={() => props.onClick(column)}
          >
            {props.render ? props.render(column) : column}
          </ColumnButton>
        ))
      : "-"}
  </div>
);

export default ColumnSection;
